export default window.configuration;
